import { SITE_IMAGES } from "@/lib/siteAssets";

export const heroSlides = [
  {
    id: 1,
    image: SITE_IMAGES.heroControlOfFibrosis,
    title: "Control of fibrosis with enhanced safety via asymmetric inhibition of prolyl-tRNA synthetase 1",
    date: "June 28, 2023",
    link: "https://target.re.kr/biomedia/44388/",
  },
  {
    id: 2,
    image: SITE_IMAGES.heroAimpDx2,
    title: "AIMP2-DX2 provides therapeutic interface to control KRAS-driven tumorigenesis",
    date: "June 28, 2023",
    link: "https://target.re.kr/biomedia/44385/",
  },
  {
    id: 3,
    image: SITE_IMAGES.heroGlucoseLeucine,
    title: "Glucose-dependent control of leucine metabolism by leucyl-tRNA synthetase 1",
    date: "January 20, 2020",
    link: "https://target.re.kr/biomedia/43829/",
  },
  {
    id: 4,
    image: SITE_IMAGES.heroAarsTherapeutic,
    title: "Aminoacyl-tRNA synthetases as therapeutic targets",
    date: "May 13, 2019",
    link: "https://target.re.kr/biomedia/43359/",
  },
  {
    id: 5,
    image: SITE_IMAGES.heroMultiTrna,
    title: "Evolution of the multi-tRNA synthetase complex and its role in cancer",
    date: "April 18, 2019",
    link: "https://target.re.kr/biomedia/42904/",
  },
];

export const newsTickerItems = [
  { id: 1, title: "\uC601\uC5D0 \uD699\uC4F8\uB358 \uC0DD\uBA85\uACFC\uD559\uC790, \uC218\uB9CE\uC740 \uB09C\uCE58\uBCD1 \uD574\uACB0\uD560 30\uB144 \uC5F0\uAD6C\uC758 \uACB0\uB860", link: "https://target.re.kr/notice/45517/" },
  { id: 2, title: "30\uB144 ARS\uC5F0\uAD6C \uC678\uAE38\u00B7\u00B7\u00B7NIH \u5148\uC81C\uC548\uC73C\uB85C \uC784\uC0C1 \uC911, \uB300\uB355\uACFC\uB3C4 \uAD50\uB958\uB97C", link: "https://target.re.kr/notice/45516/" },
  { id: 3, title: "\uC911\uAD6D \uAD6D\uAC00\uC57D\uD488\uAC10\uB3C5\uAD00\uB9AC\uAD6D, '\uB4C0\uD37C\uD2B8' \uD3D0\uC554 \uCE58\uB8CC\uC81C\uB85C \uC2B9\uC778", link: "https://target.re.kr/notice/45515/" },
  { id: 4, title: "\uC544\uC774\uBE40\uD14C\uD06C\uB180\uB85C\uC9C0\u00A9 \uCF54\uC2A4\uB2E5\uC2DC\uC7A5 \uC2E0\uADDC\uC0C1\uC7A5", link: "https://target.re.kr/notice/45426/" },
  { id: 5, title: "\uAE40\uC131\uD6C8 \uC5F0\uC138\uB300 \uAD50\uC218\uD300, \uC2E0\uAE30\uC804 \uBA74\uC5ED\uC99D\uAC15 \uBB3C\uC9C8 \uAC1C\uBC1C", link: "https://target.re.kr/notice/45428/" },
];

export const partnerBanners = [
  {
    id: 1,
    image: SITE_IMAGES.partnerZymediaBanner,
    link: "https://zymedia.co.kr",
    alt: "Zymedia",
  },
  {
    id: 2,
    image: SITE_IMAGES.partnerAibi,
    link: "https://aibi.re.kr",
    alt: "AIBI",
  },
  {
    id: 3,
    image: SITE_IMAGES.partnerBioart,
    link: "/bio-art",
    alt: "Bio-Art",
  },
];

export const govPartners = [
  {
    id: 1,
    image: SITE_IMAGES.partnerMsict,
    link: "https://www.msit.go.kr",
    alt: "Ministry of Science and ICT",
  },
  {
    id: 2,
    image: SITE_IMAGES.partnerYsu,
    link: "https://www.yonsei.ac.kr",
    alt: "Yonsei University",
  },
];

export const alliancePartners = [
  {
    id: 1,
    image: SITE_IMAGES.partnerZymedi,
    link: "https://zymedi.com",
    alt: "Zymedi",
  },
  {
    id: 2,
    image: SITE_IMAGES.partnerIvim,
    link: "http://www.ivimtech.com",
    alt: "IVIM Technology",
  },
  {
    id: 3,
    image: SITE_IMAGES.partnerMetapore,
    link: "https://metapore.com",
    alt: "MetaPore",
  },
  {
    id: 4,
    image: SITE_IMAGES.partnerMbd,
    link: "https://www.mbdbiotech.com/",
    alt: "MBD Medical & Bio Decision",
  },
  {
    id: 5,
    image: SITE_IMAGES.partnerDaewoong,
    link: "https://www.daewoong.co.kr/",
    alt: "Daewoong Pharmaceutical",
  },
  {
    id: 6,
    image: SITE_IMAGES.partnerJwBio,
    link: "http://www.jw-bioscience.co.kr/",
    alt: "JW Bioscience",
  },
];

/** 공개 일정 확정 후 true로 바꾸면 상단 메뉴에 Bio-Art가 다시 노출됩니다. */
export const BIO_ART_PUBLIC_MENU_ENABLED = false;

export const navLinks = [
  { label: "Home", href: "/" },
  { label: "About Us", href: "/about" },
  { label: "Product", href: "/product" },
  ...(BIO_ART_PUBLIC_MENU_ENABLED
    ? [{ label: "Bio-Art", href: "/bio-art" }]
    : []),
  { label: "Newsroom", href: "/newsroom" },
  { label: "Publications", href: "/publications" },
];
